// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import ReactSVG from 'react-svg';
import { translate } from "react-i18next";
import proj from 'ol/proj';

import PhotoDetails from './PhotoDetails';
import DefaultButton from './../../../components/DefaultButton';
import TextInput from './../../../components/TextInput';
import IconDelete from './../../../icons/delete.svg';
import IconCancel from './../../../icons/cancel.svg';
import IconExtent from './../../../icons/extent.svg';
import { modalInstance } from './../Content';
import BadgeIcon from '../../../components/BadgeIcon';
import IconFault from '../../../icons/Fault.svg';

import {
    selectPhoto,
    deletePhoto,
} from '../../../actions/photos';
import { centerMap } from './../../../actions/map';
import throttle from './../../../utilities/throttle';
import { BOX_EXTENT } from './../../../types/map';

const GalleryTabTitle = styled.h3`
    margin: 0 5px;
`;

const MessageWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 100%;    
    >p{
        margin-left: 5px;
        text-align: center;
    }
`;

const ThumbnailGalleryWraper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    width: 100%;
`;

const PhotosContainer = styled.div`
    overflow: auto;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    border-top: 1.5px solid rgba(128, 128, 128, 0.2);
`;

const Thumbnail = styled.img`
    width: 85%;
    min-height: 100px;
    image-rendering: pixelated;
    padding: 2px;
    border-width: 1.5px;
`;

const TitleWrapper = styled.div`
    width: 100%;
    background: linear-gradient(0deg, #263650 0%, #082242 100%);
    color: #ffffff;
    padding: 5px;
    height: 25px;
    display: 'block';
    margin-bottom: 5px;
`;

const PhotoListRow = styled.div`
    width: 100%;
    background-color: #ffffff;
    margin: 5px;
    border-radius: 5px;
    width: calc(100% - 10px);
    border: 1px solid #ebebeb;

    input[type='radio'] {
        display: none;
    }

    label {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        :hover {
            .rowTitle{
                border: 1px solid #a7c1d7;
                padding: 6.5px;
            }
        }
        .rowTitle {
            cursor: pointer;
            border: 1px solid #ebebeb;
            border-radius: 5px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 6.5px;
            >span{
                font-size: 14px;
                font-weight: 600;
            }
        }
        .filename {
            align-self: flex-start;
            margin: 6px;
            width: calc(100% - 45px);
            
            color: #2d2d2d;
            font-size: 14px;
            font-weight: 600;

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    input[type='radio']:checked+label>.rowTitle {
        border: 1.5px solid ${props => props.borderColor || '#265a9c'};
        box-shadow: 0 1px 3px #0000004d;
        padding: 6px;
    }
`;

const Row = styled.div`
    display: flex;
    margin: 0;
    padding: 0;
    align-items: center;
    width: calc(100% - 20px);
    justify-content: space-between;
    margin: 5px;
`;

const FaultIconWrapper = styled.div`
    background: #ffffffbf;
    border-radius: 5px;
    position: absolute;
    top: 50px;
    left: 24px;
    padding: 2px;
    display: flex;
`;

const StyledButton = styled(DefaultButton)`
    display: flex;
    width: 35px;
    height: 20px;
`;

const StyledSVG = styled(ReactSVG)`
    fill: #ffffff;
    width: 15px;
    height: 15px;
`;

type State = {
    filterTerm: string,
    selectedPhotos: Array<Object>,
    rowsLimit: number,
}
type Props = {
    photosDetails: Object,
    centerMap: (center: Object) => void,
    selectPhoto: (photo: Object) => void,
    lastSelectedPhoto: Object,
    t: (s: string) => string,
    roles: string,
    deletePhoto: (axiosInstance: Object, photo: string) => void,
    currentExtent: Array<number>,
}

export class GalleryModeContent extends React.Component<Props, State> {
    filterInput: any
    constructor() {
        super();
        this.state = {
            filterTerm: "",
            selectedPhotos: [],
            rowsLimit: 5,
            extentFilter: false,
        }
        // TODO: on styled-components v 4.*
        //this.galleryRef = React.createRef();
        this.selectedPhotoDetailsRef = React.createRef();
    }

    photoChangeHandler(value: string) {
        const { photosDetails, selectPhoto } = this.props;
        const id = Number(value);
        const selectedPhoto = photosDetails.find(photo => {
            return photo.id === id;
        });
        selectPhoto(
            id,
            selectedPhoto.direction
        );
    }

    onClick(value: string) {
        const { photosDetails, centerMap } = this.props;
        const selectedPhoto = photosDetails.find(photo => {
            return photo.id === Number(value);
        });
        const { longitude, latitude } = selectedPhoto;
        const center = proj.transform([longitude, latitude], "EPSG:4326", "EPSG:3857");
        centerMap(center);
    }

    togglePhotoSelection(photo) {
        const { selectedPhotos } = this.state;
        const selectedPhoto = selectedPhotos.find(testedPhoto => testedPhoto.id === photo.id);
        if (selectedPhoto) {
            this.setState({
                selectedPhotos: selectedPhotos
                    .filter(testedPhoto => testedPhoto.id !== selectedPhoto.id)
            })
        }
        else {
            this.setState({
                selectedPhotos: selectedPhotos.concat([photo])
            })
        }
    }

    customizeModalWindow() {
        const { axiosInstance, deletePhoto, t } = this.props
        const { selectedPhotos } = this.state;
        const confirmCallback = () => {
            for (let i = 0; i < selectedPhotos.length; i++) {
                deletePhoto(axiosInstance, selectedPhotos[i].id);
            }
            this.setState({
                selectedPhotos: []
            });
        }
        const config = {
            title: t('Do you really want to delete selected files') + '?',
            content: <p>{t('Do you really want to delete selected files')}?</p>,
            confirmCallback: confirmCallback,
            cancelBtnVisible: true,
            confirmBtnVisible: true,
            confirmBtnText: t('Delete'),
            closeOnConfirm: true,
            type: 'warning',
        }
        modalInstance.customize(config);
    }

    scrollToSelectedPhoto() {
        // offsetTop value is correct only when DOM render is finished (new photoDetails have shown)
        setTimeout(() => {
            if (this.selectedPhotoDetailsRef.current) {
                const offsetTop = this.selectedPhotoDetailsRef.current.offsetTop - 145;
                // TODO: on styled-components v 4.*
                this.galleryRef.scrollTop = offsetTop;
            }
        }, 500);
    }

    componentDidUpdate(prevProps) {
        const { lastSelectedPhoto, photosDetails } = this.props;
        const { rowsLimit } = this.state;

        if (lastSelectedPhoto && prevProps.lastSelectedPhoto !== lastSelectedPhoto) {
            const selectedIndex = photosDetails.findIndex(photoDetails => {
                return lastSelectedPhoto === photoDetails.id;
            });

            if (rowsLimit < selectedIndex + 5) {
                throttle.run(() => {
                    this.setState({ rowsLimit: selectedIndex + 5 });
                    this.scrollToSelectedPhoto();
                }, 500);
            } else {
                this.scrollToSelectedPhoto();
            }
        }
    }

    render() {
        const { BASE_URL, photosDetails, lastSelectedPhoto, t, roles, chosenFlight, boxExtent } = this.props;
        const { filterTerm, selectedPhotos, extentFilter } = this.state;
        const token = localStorage.getItem('token');

        if (!chosenFlight || photosDetails.length === 0) {
            return (
                <ThumbnailGalleryWraper>
                    <TitleWrapper>
                        <GalleryTabTitle>
                            {t('Photos')}:
                    </GalleryTabTitle>
                    </TitleWrapper>
                    <MessageWrapper>
                        <p>
                            {chosenFlight ? t('No photos for chosen mission') : t('No mission selected please select')}
                        </p>
                    </MessageWrapper>
                </ThumbnailGalleryWraper>
            );
        }

        return (
            <ThumbnailGalleryWraper>
                <TitleWrapper>
                    <GalleryTabTitle>
                        {t('Photos')}:
                    </GalleryTabTitle>
                </TitleWrapper>

                <div
                    style={{
                        position: 'relative',
                        width: '100%',
                    }}>
                    <TextInput
                        style={{
                            width: 'calc(100% - 14px)',
                            margin: '2px 7px 0px 7px',
                        }}
                        ref={(node) => { this.filterInput = node }}
                        type="text"
                        placeholder={t('Search') + '...'}
                        onChange={(event) => {
                            const { value } = event.target;
                            throttle.run(() => {
                                this.setState({ filterTerm: value })
                            }, 500)
                        }}
                    />
                    <DefaultButton
                        style={{
                            position: 'absolute',
                            right: '10px',
                            top: '6px',
                        }}
                        visible={filterTerm !== ''}
                        title={t('Clear')}
                        onClick={() => {
                            this.setState({
                                filterTerm: ''
                            })
                            this.filterInput.domNode.value = '';
                        }}>
                        <ReactSVG
                            path={IconCancel}
                            style={{
                                fill: '#ffffff',
                                width: '20px',
                                height: '20px'
                            }}
                        />
                    </DefaultButton>
                </div>
                <Row>
                    <StyledButton
                        type='warning'
                        title={t('Delete')}
                        disabled={roles === 'Regular' || this.state.selectedPhotos.length === 0}
                        onClick={() => {
                            this.customizeModalWindow();
                            modalInstance.show();
                        }}>
                        <StyledSVG path={IconDelete} />
                    </StyledButton>
                    <StyledButton
                        title={t('filter by map extend')}
                        onClick={() => {
                            this.setState(prevState => ({ extentFilter: !prevState.extentFilter }))
                        }}
                        active={extentFilter}>
                        <StyledSVG path={IconExtent} />
                    </StyledButton>
                </Row>

                <PhotosContainer
                    // TODO: deprecated in styled-components 4.*
                    innerRef={(node) => { this.galleryRef = node }}
                    onScroll={(e) => {
                        const threshold = 50;
                        const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + threshold
                        if (bottom) {
                            throttle.run(() => {
                                this.setState({ rowsLimit: this.state.rowsLimit + 5 })
                            }, 500)
                        }
                    }}
                >
                    {photosDetails
                        .filter(photoDetails => {
                            const { fileName, longitude, latitude } = photoDetails;
                            const filterResult = fileName.toUpperCase().includes(filterTerm.toUpperCase())
                                && (extentFilter
                                    ? boxExtent.intersectsCoordinate(proj.transform([longitude, latitude], "EPSG:4326", "EPSG:3857"))
                                    : true);
                            return filterResult;
                        })
                        .slice(0, this.state.rowsLimit)
                        .map(photoDetails => {
                            const url = `${BASE_URL}photos/${photoDetails.id}/thumbnail?token=${token}`
                            const selected = selectedPhotos.find(testedPhoto => {
                                return testedPhoto.id === photoDetails.id;
                            });

                            return (
                                <div
                                    ref={lastSelectedPhoto === photoDetails.id ? this.selectedPhotoDetailsRef : null}
                                    key={photoDetails.id}>
                                    <PhotoListRow
                                        borderColor={photoDetails.moduleColor}>
                                        <input
                                            id={`photo_${String(photoDetails.id)}_radio`}
                                            type='radio'
                                            name='photo'
                                            value={photoDetails.id}
                                            checked={lastSelectedPhoto === photoDetails.id}
                                            onChange={(e) => {
                                                this.photoChangeHandler(e.target.value)
                                            }}
                                            onClick={(e) => {
                                                this.onClick(e.target.value)
                                            }} />
                                        <label htmlFor={`photo_${String(photoDetails.id)}_radio`}
                                            style={{
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}>
                                            <div className='rowTitle' style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'unset'
                                            }}>
                                                <span className='filename'>
                                                    {photoDetails.fileName}
                                                </span>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>
                                                    <Thumbnail
                                                        className='rowTitle'
                                                        src={url}
                                                    />
                                                </div>
                                                {photoDetails.faultsCount ?
                                                    <FaultIconWrapper>
                                                        <BadgeIcon
                                                            marginRight='0px'
                                                            color='#E2574C'
                                                            path={IconFault}
                                                            count={photoDetails.faultsCount} />
                                                    </FaultIconWrapper> : null}
                                                <PhotoDetails
                                                    photoDetails={photoDetails}
                                                    visible={lastSelectedPhoto === photoDetails.id}
                                                    togglePhotoSelection={this.togglePhotoSelection.bind(this)}
                                                    selected={selected}
                                                />
                                            </div>
                                        </label>
                                    </PhotoListRow>
                                </div>
                            )
                        })
                    }
                </PhotosContainer>
            </ThumbnailGalleryWraper>
        );
    };
};

const mapStateToProps = state => ({
    roles: state.auth.get('roles'),
    axiosInstance: state.auth.get('axiosInstance'),
    photosDetails: state.photos.get('photos'),
    lastSelectedPhoto: state.photos.get('selectedPhotoId'),
    chosenFlight: state.flightManager.get('chosenFlight'),
    boxExtent: state.mapData.get(BOX_EXTENT),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    selectPhoto,
    deletePhoto,
    centerMap,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(GalleryModeContent));


// WEBPACK FOOTER //
// ./src/containers/content/rightPanelContent/GalleryModeContent.jsx